import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CSpinner,
  CCardBody,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
  CCol,
  CButton,
  CInputRadio,
  CLabel,
  CInput,
  CSelect /* , CCollapse */
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import { profileCreate } from "../../../../actions/profileActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

import "../users.css";

class UserCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // user_cadastro: {},
      // photo: "",
      edit: false,
      // user: {},
      loading: true,
      creating: false,
      roles: [],
      schools: [],
      regions: [],
      groups: [],
      selectedRoles: [],
      principal: null,
      name: null,
      email: null,
      username: null,
      phone: null,
      birthday: null,
      password: null,
      confirm_password: null,
      gender: null,
      submitButton: false,
      hasUnsavedChanges: false
    };

    this.formRef = React.createRef();
    this.error = this.error.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.validator = this.validator.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  validator(validator) {
    for (let i = 0; i < validator.length; i++) {
      if (!validator[i].value) {
        toastr.error("Erro", `Favor preencher o campo ${validator[i].label}`);
        return false;
      }
    }

    return true;
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ creating: true });
    const { id } = this.props.match.params;
    this.setState(
      () => ({
        loading: true
      }),
      () => {
        axios
          .get(`${URL.api}access/role/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            respRole => {
              axios
                .get(`${URL.api}access/region/list`, {
                  headers: { authorization: `Bearer ${this.props.user.token}` }
                })
                .then(
                  respRegion => {
                    axios
                      .get(`${URL.api}access/group/list`, {
                        headers: {
                          authorization: `Bearer ${this.props.user.token}`
                        }
                      })
                      .then(
                        respGroup => {
                          axios
                            .get(`${URL.api}access/school/list`, {
                              headers: {
                                authorization: `Bearer ${this.props.user.token}`
                              }
                            })
                            .then(
                              respSchool => {
                                const roles = [
                                  "G",
                                  "U",
                                  "R",
                                  "E",
                                  "P",
                                  "A",
                                  "S",
                                  "V"
                                ];

                                if (
                                  (this.props.user.user_roles[0].group_id ===
                                    79 ||
                                    this.props.user.user_roles[0].group_id ===
                                      80 ||
                                    this.props.user.user_roles[0].group_id ===
                                      45) &&
                                  this.props.user.user_roles[0].role_id === 4
                                ) {
                                  respRole.data.data.splice(5, 1);
                                }

                                this.setState(
                                  () => ({
                                    roles: respRole.data.data
                                      .filter(
                                        role =>
                                          this.props.general.active_roles
                                            .type === "G" ||
                                          roles.indexOf(role.type) >=
                                            roles.indexOf(
                                              this.props.general.active_roles
                                                .type
                                            )
                                      )
                                      .map(item => ({
                                        value: item.id,
                                        label: item.name,
                                        type: item.type
                                      })),
                                    groups: respGroup.data.data.map(item => ({
                                      value: item.id,
                                      label: item.name
                                    })),
                                    regions: respRegion.data.data.map(item => ({
                                      value: item.id,
                                      label: item.name,
                                      group_id: item.group_id
                                    })),
                                    schools: respSchool.data.data.map(item => ({
                                      value: item.id,
                                      label: item.name,
                                      region_id: item.region_id
                                    }))
                                  }),
                                  () => {
                                    if (!id) {
                                      this.setState(() => ({
                                        loading: false
                                      }));
                                    } else {
                                      axios
                                        .get(
                                          `${URL.api}access/user/singleView/${id}`,
                                          {
                                            headers: {
                                              authorization: `Bearer ${this.props.user.token}`
                                            }
                                          }
                                        )
                                        .then(
                                          resp => {
                                            this.setState(
                                              () => ({
                                                name: resp.data.data.user.name,
                                                email:
                                                  resp.data.data.user.email,
                                                username:
                                                  resp.data.data.user.username,
                                                phone:
                                                  resp.data.data.user.phone,
                                                birthday:
                                                  resp.data.data.user_complement
                                                    ?.birthday || null,
                                                gender:
                                                  resp.data.data.user_complement
                                                    ?.gender || null,
                                                selectedRoles:
                                                  resp.data.data.user_role.map(
                                                    item => ({
                                                      role_id: item.role_id,
                                                      group_id: item.group_id,
                                                      region_id: item.region_id,
                                                      school_id: item.school_id,
                                                      role_type:
                                                        respRole.data.data.find(
                                                          role =>
                                                            role?.id ===
                                                            item?.role_id
                                                        )?.type
                                                    })
                                                  ),
                                                principal:
                                                  resp.data.data.user_role.findIndex(
                                                    item =>
                                                      item.principal === true
                                                  )
                                              }),
                                              () => {
                                                this.setState(() => ({
                                                  edit: true,
                                                  loading: false
                                                }));
                                              }
                                            );
                                          },
                                          error => {
                                            this.error(
                                              "Não foi possível obter informações do usuário"
                                            );
                                          }
                                        );
                                    }
                                  }
                                );
                              },
                              error => {
                                this.error(
                                  "Não foi possível listar as escolas"
                                );
                              }
                            );
                        },
                        error => {
                          this.error("Não foi possível listar os grupos");
                        }
                      );
                  },
                  error => {
                    this.error("Não foi possível listar os regionais");
                  }
                );
            },
            error => {
              this.error("Não foi possível listar os perfis");
            }
          );
      }
    );
  }

  enviar() {
    if (
      !this.state.username ||
      !this.state.email ||
      !this.state.name ||
      !this.state.password
    ) {
      toastr.warning("Atenção", "Preencha todos os campos obrigatórios");
      return;
    }

    if (this.state.password.length < 8) {
      toastr.warning("Atenção", "A senha deve conter ao menos 8 caracteres");
      return;
    }

    if (this.state.selectedRoles.length === 0) {
      toastr.warning("Atenção", "Escolha ao menos um perfil");
      return;
    }

    if (this.state.principal === null) {
      toastr.warning("Atenção", "Marque ao menos um perfil como principal");
      return;
    }

    if (this.state.password !== this.state.confirm_password) {
      toastr.warning("Atenção", "As senhas não coincidem");
      return;
    }

    const role = this.state.selectedRoles.map((item, index) => ({
      role_id: item.role_id,
      group_id: ["U", "R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.group_id
        : null,
      region_id: ["R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.region_id
        : null,
      school_id: ["E", "P", "A", "S"].includes(item.role_type)
        ? item.school_id
        : null,
      principal: this.state.principal === index
    }));

    for (let i = 0; i < role.length; i++) {
      if (!role[i].role_id) {
        toastr.warning("Atenção", "Você precisa selecionar um perfil");
        return;
      }

      if (
        role[i].role_id === 2 &&
        role[i].group_id === null &&
        this.state.selectedRoles[i].role_type !== "V"
      ) {
        toastr.warning("Atenção", "Você precisa selecionar um grupo");
        return;
      }

      if (
        role[i].role_id === 3 &&
        role[i].region_id === null &&
        this.state.selectedRoles[i].role_type !== "V"
      ) {
        toastr.warning("Atenção", "Você precisa selecionar uma regional");
        return;
      }

      if (
        role[i].role_id >= 4 &&
        role[i].school_id === null &&
        this.state.selectedRoles[i].role_type !== "V"
      ) {
        toastr.warning("Atenção", "Você precisa selecionar uma escola");
        return;
      }
    }

    this.setState({ creating: true });
    this.setState({ submitButton: true });

    let obj = {
      loggedUser: this.props.user.user.id,
      name: this.state.name,
      email: this.state.email,
      username: this.state.username,
      password: this.state.password,
      phone: this.state.phone,
      language_id: 1,
      expiration: 0,
      complement: {
        birthday: this.state.birthday,
        gender: this.state.gender,
        city: null,
        country: null
      },
      role
    };

    try {
      axios
        .post(`${URL.api}access/user/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          if (resp.data.success) {
            toastr.success("Sucesso", "Usuário inserido com sucesso");
            this.setState({ hasUnsavedChanges: false }, () => {
              // Navega apenas depois que o estado foi atualizado
              this.props.history.push("/userlist");
            });
          } else if (
            resp.data.error === "Já existe um usuário com esse login"
          ) {
            toastr.warning("Atenção", "Já existe um usuário com esse login");
          } else {
            this.error("Não foi possível inserir o usuário");
          }
        });
    } catch (err) {
      this.error("Não foi possível inserir o usuário. Problemas de conexão!");
    } finally {
      this.setState({ submitButton: false });
    }
  }

  atualizar() {
    if (!this.state.username || !this.state.email || !this.state.name) {
      toastr.warning("Atenção", "Preencha todos os campos obrigatórios");
      return;
    }

    if (this.state.selectedRoles.length === 0) {
      toastr.warning("Atenção", "Escolha ao menos um perfil");
      return;
    }

    if (this.state.principal === null) {
      toastr.warning("Atenção", "Marque ao menos um perfil como principal");
      return;
    }

    // this.setState({ creating: true});
    this.setState({ submitButton: true });

    const role = this.state.selectedRoles.map((item, index) => ({
      role_id: item.role_id,
      group_id: ["U", "R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.group_id
        : null,
      region_id: ["R", "E", "P", "A", "S"].includes(item.role_type)
        ? item.region_id
        : null,
      school_id: ["E", "P", "A", "S"].includes(item.role_type)
        ? item.school_id
        : null,
      principal: this.state.principal === index
    }));

    for (let i = 0; i < role.length; i++) {
      if (!role[i].role_id) {
        toastr.warning("Atenção", "Você precisa selecionar um perfil");
        return;
      }

      if (role[i].role_id === 2 && role[i].group_id === null) {
        toastr.warning("Atenção", "Você precisa selecionar um grupo");
        return;
      }

      if (role[i].role_id === 3 && role[i].region_id === null) {
        toastr.warning("Atenção", "Você precisa selecionar uma regional");
        return;
      }

      if (role[i].role_id >= 4 && role[i].school_id === null) {
        toastr.warning("Atenção", "Você precisa selecionar uma escola");
        return;
      }
    }

    let obj = {
      loggedUser: this.props.user.user.id,
      name: this.state.name,
      email: this.state.email,
      username: this.state.username,
      phone: this.state.phone,
      complement: {
        birthday: this.state.birthday,
        gender: this.state.gender,
        city: null,
        country: null
      },
      role
    };

    axios
      .post(`${URL.api}access/user/update/${this.props.match.params.id}`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            this.props.history.push("/userlist");
            this.setState(
              {
                creating: false,
                submitButton: false,
                hasUnsavedChanges: false
              },
              () => {
                // Navega depois do estado atualizado
                this.props.history.push("/userlist");
              }
            );
          } else {
            this.error("Não foi possível editar o usuário");
            this.setState({ creating: false, submitButton: false });
          }
        },
        error => {
          this.error("Não foi possível editar o usuário");
          this.setState({ creating: false, submitButton: false });
        }
      );
  }

  done(uploads) {
    this.setState(() => ({
      // photo: uploads[0]
    }));
  }

  addRole() {
    this.setState(state => {
      const prev = [...state.selectedRoles];
      prev.push({
        role_id: null,
        group_id: this.props.general.active_roles.group_id,
        region_id: this.props.general.active_roles.region_id,
        school_id: this.props.general.active_roles.school_id,
        role_type: null
      });

      return { selectedRoles: prev };
    });
  }

  removeRole(index) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev.splice(index, 1);

      let { principal } = state;

      if (principal === index) {
        principal = null;
      } else if (principal > index) {
        principal -= 1;
      }

      return { selectedRoles: prev, principal };
    });
  }

  changeRole(index, value, type) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].role_id = value;
      prev[index].role_type = type;

      return { selectedRoles: prev };
    });
  }

  changeGroup(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].group_id = value;
      prev[index].region_id = null;
      prev[index].school_id = null;

      return { selectedRoles: prev };
    });
  }

  changeRegion(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].region_id = value;
      prev[index].school_id = null;

      return { selectedRoles: prev };
    });
  }

  changeSchool(index, value) {
    this.setState(state => {
      let prev = [...state.selectedRoles];
      prev[index].school_id = value;

      return { selectedRoles: prev };
    });
  }

  render() {
    // onSubmit = {this.state.edit?this.atualizar:this.enviar}
    return (
      <>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/Userlist", to: "/Userlist" }]}
        />
        {/* Aqui */}
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard className="card-overflow">
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar usuário" : "Criar usuário"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite o usuário selecionado"
                    : "Crie um novo usuário"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() =>
                  this.state.edit ? this.atualizar() : this.enviar()
                }
                disabled={!this.state.creating}
              >
                <>
                  <span style={this.state.submitButton ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.submitButton && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody className="card-overflow">
              <CFormGroup>
                <CLabel>Nome</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-user"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="text"
                    value={this.state.name}
                    onChange={e =>
                      this.setState({
                        name: e.target.value,
                        hasUnsavedChanges: true
                      })
                    }
                    placeholder="Digite o nome"
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>E-mail</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-envelope-o"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="text"
                    value={this.state.email}
                    onChange={e => this.setState({ email: e.target.value })}
                    placeholder="Digite o e-mail"
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Login</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-id-card-o"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="text"
                    value={this.state.username}
                    onChange={e => this.setState({ username: e.target.value })}
                    placeholder="Digite o login"
                  />
                </CInputGroup>
              </CFormGroup>
              {!this.state.edit && (
                <>
                  <CFormGroup>
                    <CLabel>Senha</CLabel>
                    <CInputGroup className="input-prepend">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-key"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="password"
                        value={this.state.password}
                        onChange={e =>
                          this.setState({ password: e.target.value })
                        }
                        placeholder="Digite a senha"
                      />
                    </CInputGroup>
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel>Digite novamente sua senha</CLabel>
                    <CInputGroup className="input-prepend">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-key"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        type="password"
                        value={this.state.confirm_password}
                        onChange={e =>
                          this.setState({ confirm_password: e.target.value })
                        }
                        placeholder="Confirme a senha"
                      />
                    </CInputGroup>
                  </CFormGroup>
                </>
              )}
              <CFormGroup>
                <CLabel>Telefone (opcional)</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-phone"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="phone"
                    value={this.state.phone}
                    onChange={e => this.setState({ phone: e.target.value })}
                    placeholder="Digite o telefone"
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Data de nascimento (opcional)</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-calendar-o"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CInput
                    type="date"
                    value={this.state.birthday}
                    onChange={e => this.setState({ birthday: e.target.value })}
                    max="2021-01-01"
                    min="1930-01-01"
                  />
                </CInputGroup>
              </CFormGroup>
              <CFormGroup>
                <CLabel>Gênero (opcional)</CLabel>
                <CInputGroup className="input-prepend">
                  <CInputGroupPrepend>
                    <CInputGroupText>
                      <i className="fa fa-venus-mars"></i>
                    </CInputGroupText>
                  </CInputGroupPrepend>
                  <CSelect
                    value={this.state.gender}
                    onChange={e => this.setState({ gender: e.target.value })}
                  >
                    <option>Escolha um gênero</option>
                    <option value="Masculino">Masculino</option>
                    <option value="Feminino">Feminino</option>
                  </CSelect>
                </CInputGroup>
              </CFormGroup>
              <CLabel className="d-block">Perfis</CLabel>
              {this.state.selectedRoles.map((item, index) => (
                <div
                  className="d-flex w-100 mb-3 align-items-center"
                  key={index}
                >
                  <CRow style={{ flex: 1 }} className="mr-3">
                    <CCol xs="3">
                      <CFormGroup className="m-0">
                        <CInputGroup className="input-prepend">
                          <CInputGroupPrepend>
                            <CInputGroupText>
                              <i className="fa fa-user"></i>
                            </CInputGroupText>
                          </CInputGroupPrepend>
                          <Select
                            isSearchable
                            placeholder="Perfil"
                            name="Perfil"
                            options={this.state.roles}
                            classNamePrefix="select"
                            className="flex-1"
                            value={this.state.roles.find(
                              option => option.value === item.role_id
                            )}
                            defaultValue={this.state.roles.find(
                              option => option.value === item.role_id
                            )}
                            onChange={e =>
                              this.changeRole(index, e.value, e.type)
                            }
                          />
                        </CInputGroup>
                      </CFormGroup>
                    </CCol>
                    <CCol xs="3">
                      {["U", "R", "E", "P", "A", "S"].includes(
                        item.role_type
                      ) && (
                        <CFormGroup className="m-0">
                          <CInputGroup className="input-prepend">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-user"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Select
                              isSearchable
                              placeholder="Grupo"
                              name="Grupo"
                              options={this.state.groups}
                              classNamePrefix="select"
                              className="flex-1"
                              value={
                                this.state.groups.find(
                                  option => option.value === item.group_id
                                ) || { value: null, label: "Grupo" }
                              }
                              defaultValue={this.state.groups.find(
                                option => option.value === item.group_id
                              )}
                              onChange={e => this.changeGroup(index, e.value)}
                              isDisabled={
                                this.props.general.active_roles.group_id !==
                                null
                              }
                            />
                          </CInputGroup>
                        </CFormGroup>
                      )}
                    </CCol>
                    <CCol xs="3">
                      {["R", "E", "P", "A", "S"].includes(item.role_type) && (
                        <CFormGroup className="m-0">
                          <CInputGroup className="input-prepend">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-user"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Select
                              isSearchable
                              placeholder="Região"
                              name="Região"
                              options={this.state.regions.filter(
                                region => region.group_id === item.group_id
                              )}
                              classNamePrefix="select"
                              className="flex-1"
                              value={
                                this.state.regions.find(
                                  option => option.value === item.region_id
                                ) || { value: null, label: "Região" }
                              }
                              defaultValue={this.state.regions.find(
                                option => option.value === item.region_id
                              )}
                              onChange={e => this.changeRegion(index, e.value)}
                              isDisabled={
                                this.props.general.active_roles.region_id !==
                                null
                              }
                            />
                          </CInputGroup>
                        </CFormGroup>
                      )}
                    </CCol>
                    <CCol xs="3">
                      {["E", "P", "A", "S"].includes(item.role_type) && (
                        <CFormGroup className="m-0">
                          <CInputGroup className="input-prepend">
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-user"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <Select
                              isSearchable
                              placeholder="Escola"
                              name="Escola"
                              options={this.state.schools.filter(
                                region => region.region_id === item.region_id
                              )}
                              classNamePrefix="select"
                              className="flex-1"
                              value={
                                this.state.schools.find(
                                  option => option.value === item.school_id
                                ) || { value: null, label: "Escola" }
                              }
                              defaultValue={this.state.schools.find(
                                option => option.value === item.school_id
                              )}
                              onChange={e => this.changeSchool(index, e.value)}
                              isDisabled={
                                this.props.general.active_roles.school_id !==
                                null
                              }
                            />
                          </CInputGroup>
                        </CFormGroup>
                      )}
                    </CCol>
                  </CRow>
                  <CFormGroup className="mb-0">
                    <CInputRadio
                      className="form-check-input"
                      checked={this.state.principal === index}
                      onChange={() => this.setState({ principal: index })}
                    />
                    <CLabel className="m-0">Principal</CLabel>
                  </CFormGroup>
                  <CButton
                    variant="outline"
                    color="secondary"
                    className="ml-3 text-dark"
                    onClick={() => this.removeRole(index)}
                  >
                    <i className="fa fa-trash"></i>
                  </CButton>
                </div>
              ))}
              <CButton
                variant="outline"
                color="secondary"
                className="text-dark"
                onClick={() => this.addRole()}
              >
                Adicionar um perfil
              </CButton>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );

    // return (
    //   <>
    //     {this.state.loading ? (
    //       <Loading />
    //     ) : (
    //       <CCard>
    //         <CCardHeader className="d-flex align-items-center">
    //           <div
    //             style={{ display: "flex", flexDirection: "column", flex: 1 }}
    //           >
    //             <h4 className="card-title mb-1">
    //               {this.state.edit ? "Editar Usuário" : "Criar Usuário"}
    //             </h4>
    //             <div className="small text-muted">
    //               {this.state.edit
    //                 ? "Edite o usuário selecionado"
    //                 : "Crie um novo usuário"}
    //             </div>
    //           </div>
    //           <CButtonGroup style={{ marginRight: "10px" }}>
    //             <CButton
    //               color="outline-secondary"
    //               className="text-muted"
    //               onClick={() => this.previous()}
    //               disabled={this.state.fase === 1}
    //             >
    //               <i className="fa fa-caret-left"></i>
    //             </CButton>
    //             <CButton
    //               color="outline-secondary"
    //               className="text-muted"
    //               onClick={() => this.next()}
    //               disabled={this.state.fase === this.state.fases}
    //             >
    //               <i className="fa fa-caret-right"></i>
    //             </CButton>
    //           </CButtonGroup>
    //           <CButton
    //             color="primary"
    //             onClick={() => this.formRef.current.submit()}
    //             disabled={this.state.fase !== this.state.fases}
    //           >
    //             <i className="fa fa-cloud-upload mr-2"></i>Salvar
    //           </CButton>
    //         </CCardHeader>
    //         <ProgressTracker
    //           current={this.state.fase}
    //           total={this.state.fases}
    //         />
    //         <CCardBody>
    //           {this.state.fase === 1 ? (
    //             <div>
    //               <Form2
    //                 avatar
    //                 fields={this.state.fields1}
    //                 back={false}
    //                 history={this.props.history}
    //                 initialValues={this.state.user_cadastro}
    //                 edit={this.state.edit}
    //               />
    //               <div
    //                 className="bg-light p-3 text-muted d-flex align-items-center"
    //                 style={{ borderRadius: "0.25rem" }}
    //               >
    //                 Para seguir para o próximo passo, clique em{" "}
    //                 <i className="fa fa-caret-right mx-2"></i> no canto superior
    //                 direito
    //               </div>
    //             </div>
    //           ) : this.state.fase === 2 ? (
    //             <div>
    //               <Form2
    //                 avatar
    //                 fields={this.state.fields2}
    //                 back={false}
    //                 history={this.props.history}
    //                 initialValues={this.state.user_cadastro}
    //                 edit={this.state.edit}
    //               />
    //               <div
    //                 className="bg-light p-3 text-muted d-flex align-items-center"
    //                 style={{ borderRadius: "0.25rem" }}
    //               >
    //                 Para seguir para o próximo passo, clique em{" "}
    //                 <i className="fa fa-caret-right mx-2"></i> no canto superior
    //                 direito
    //               </div>
    //             </div>
    //           ) : (
    //             <div>
    //               <Form2
    //                 avatar
    //                 fields={[]}
    //                 back={false}
    //                 history={this.props.history}
    //                 ref={this.formRef}
    //                 onSubmit={this.state.edit ? this.atualizar : this.enviar}
    //                 initialValues={this.state.user_cadastro}
    //                 edit={this.state.edit}
    //               />
    //               {this.state.selectedRoles.map((item, index) => (
    //                 <div
    //                   className="d-flex w-100 mb-3 align-items-center"
    //                   key={index}
    //                 >
    //                   <CRow style={{ flex: 1 }} className="mr-3">
    //                     <CCol xs="3">
    //                       <CFormGroup className="m-0">
    //                         <CInputGroup className="input-prepend">
    //                           <CInputGroupPrepend>
    //                             <CInputGroupText>
    //                               <i className="fa fa-user"></i>
    //                             </CInputGroupText>
    //                           </CInputGroupPrepend>
    //                           <Select
    //                             isSearchable
    //                             placeholder="Perfil"
    //                             name="Perfil"
    //                             options={this.state.roles}
    //                             classNamePrefix="select"
    //                             className="flex-1"
    //                             value={this.state.roles.find(
    //                               option => option.value === item.role_id
    //                             )}
    //                             defaultValue={this.state.roles.find(
    //                               option => option.value === item.role_id
    //                             )}
    //                             onChange={e =>
    //                               this.changeRole(index, e.value, e.type)
    //                             }
    //                           />
    //                         </CInputGroup>
    //                       </CFormGroup>
    //                     </CCol>
    //                     <CCol xs="3">
    //                       {["U", "R", "E", "P", "A", "S"].includes(
    //                         item.role_type
    //                       ) && (
    //                         <CFormGroup className="m-0">
    //                           <CInputGroup className="input-prepend">
    //                             <CInputGroupPrepend>
    //                               <CInputGroupText>
    //                                 <i className="fa fa-user"></i>
    //                               </CInputGroupText>
    //                             </CInputGroupPrepend>
    //                             <Select
    //                               isSearchable
    //                               placeholder="Grupo"
    //                               name="Grupo"
    //                               options={this.state.groups}
    //                               classNamePrefix="select"
    //                               className="flex-1"
    //                               value={
    //                                 this.state.groups.find(
    //                                   option => option.value === item.group_id
    //                                 ) || { value: null, label: "Grupo" }
    //                               }
    //                               defaultValue={this.state.groups.find(
    //                                 option => option.value === item.group_id
    //                               )}
    //                               onChange={e =>
    //                                 this.changeGroup(index, e.value)
    //                               }
    //                               isDisabled={
    //                                 this.props.general.active_roles.group_id !==
    //                                 null
    //                               }
    //                             />
    //                           </CInputGroup>
    //                         </CFormGroup>
    //                       )}
    //                     </CCol>
    //                     <CCol xs="3">
    //                       {["R", "E", "P", "A", "S"].includes(
    //                         item.role_type
    //                       ) && (
    //                         <CFormGroup className="m-0">
    //                           <CInputGroup className="input-prepend">
    //                             <CInputGroupPrepend>
    //                               <CInputGroupText>
    //                                 <i className="fa fa-user"></i>
    //                               </CInputGroupText>
    //                             </CInputGroupPrepend>
    //                             <Select
    //                               isSearchable
    //                               placeholder="Região"
    //                               name="Região"
    //                               options={this.state.regions.filter(
    //                                 region => region.group_id === item.group_id
    //                               )}
    //                               classNamePrefix="select"
    //                               className="flex-1"
    //                               value={
    //                                 this.state.regions.find(
    //                                   option => option.value === item.region_id
    //                                 ) || { value: null, label: "Região" }
    //                               }
    //                               defaultValue={this.state.regions.find(
    //                                 option => option.value === item.region_id
    //                               )}
    //                               onChange={e =>
    //                                 this.changeRegion(index, e.value)
    //                               }
    //                               isDisabled={
    //                                 this.props.general.active_roles
    //                                   .region_id !== null
    //                               }
    //                             />
    //                           </CInputGroup>
    //                         </CFormGroup>
    //                       )}
    //                     </CCol>
    //                     <CCol xs="3">
    //                       {["E", "P", "A", "S"].includes(item.role_type) && (
    //                         <CFormGroup className="m-0">
    //                           <CInputGroup className="input-prepend">
    //                             <CInputGroupPrepend>
    //                               <CInputGroupText>
    //                                 <i className="fa fa-user"></i>
    //                               </CInputGroupText>
    //                             </CInputGroupPrepend>
    //                             <Select
    //                               isSearchable
    //                               placeholder="Escola"
    //                               name="Escola"
    //                               options={this.state.schools.filter(
    //                                 region =>
    //                                   region.region_id === item.region_id
    //                               )}
    //                               classNamePrefix="select"
    //                               className="flex-1"
    //                               value={
    //                                 this.state.schools.find(
    //                                   option => option.value === item.school_id
    //                                 ) || { value: null, label: "Escola" }
    //                               }
    //                               defaultValue={this.state.schools.find(
    //                                 option => option.value === item.school_id
    //                               )}
    //                               onChange={e =>
    //                                 this.changeSchool(index, e.value)
    //                               }
    //                               isDisabled={
    //                                 this.props.general.active_roles
    //                                   .school_id !== null
    //                               }
    //                             />
    //                           </CInputGroup>
    //                         </CFormGroup>
    //                       )}
    //                     </CCol>
    //                   </CRow>
    //                   <CFormGroup className="mb-0">
    //                     <CInputRadio
    //                       className="form-check-input"
    //                       checked={this.state.principal === index}
    //                       onChange={() => this.setState({ principal: index })}
    //                     />
    //                     <CLabel className="m-0">Principal</CLabel>
    //                   </CFormGroup>
    //                   <CButton
    //                     variant="outline"
    //                     color="secondary"
    //                     className="ml-3 text-dark"
    //                     onClick={() => this.removeRole(index)}
    //                   >
    //                     <i className="fa fa-trash"></i>
    //                   </CButton>
    //                 </div>
    //               ))}
    //               <CButton
    //                 variant="outline"
    //                 color="secondary"
    //                 className="text-dark"
    //                 onClick={() => this.addRole()}
    //               >
    //                 Adicionar um perfil
    //               </CButton>
    //             </div>
    //           )}
    //         </CCardBody>
    //       </CCard>
    //     )}
    //   </>
    // );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      profileCreate,
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserCreate);
